import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,  FormControl} from 'react-bootstrap';
 import moment   from 'moment'
import config from  '../../../config';
import json2csv   from 'json2csv'


import Select   from 'react-select'
  import {prepareSelectOptionsList,filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';
 const allReportFieldList = [
     {label: 'Type', value:'Type'},
     {label: 'Email', value:'Email'},
     {label: 'User First Name', value:'UserID.firstName'},
     {label: 'User Last Name', value:'UserID.lastName'},
     {label: 'Product Name', value:'Product.ProductName'},
     {label: 'Product ID', value:'Product.ShopifyProductID'},
    {label: 'Brand', value:'GBGProductID.Brand'},
     {label: 'Model', value:'GBGProductID.Model'},
     {label: 'TextToMatch', value:'TextToMatch'},
     {label: 'Desirable Price', value:'DesirablePrice'},
     {label: 'Email Sent ', value:'EmailsSent'},
     {label: 'Created At ', value:'createdAt'},
     {label: 'Data ', value:'Data'},
     {label: 'Deleted ', value:'Deleted'},

]

export default class AdminSubscriptionsActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
             pending: false,
            reportFields: [
                {label: 'Type', value:'Type'},
                {label: 'Email', value:'Email'},
                {label: 'User First Name', value:'UserID.firstName'},
                {label: 'User Last Name', value:'UserID.lastName'},
                {label: 'Product Name', value:'Product.ProductName'},
                {label: 'Product ID', value:'Product.ShopifyProductID'},
                {label: 'Brand', value:'GBGProductID.Brand'},
                {label: 'Model', value:'GBGProductID.Model'},
                {label: 'TextToMatch', value:'TextToMatch'},
                {label: 'Desirable Price', value:'DesirablePrice'},
                {label: 'Email Sent ', value:'EmailsSent'},
                {label: 'Created At ', value:'createdAt'},
                {label: 'Data ', value:'Data'},
                {label: 'Deleted ', value:'Deleted'},

            ]
         };

    };




    downloadReport(){
         var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
             overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
          var queryParams = {'records': this.props.recordIDs, reportType:'subscriptions' }

        this.props.makeRequest(queryParams, methodData).then(res => {
           var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })
            var dataToExport  = _.map(res.data, function (record) {
                record.EmailsSent =   _.map(_.get(record,'EmailsSent',[]), function (emailSent, index) {

                    return {'Sent At':moment(emailSent.createdAt).format("YYYY-MM-DD HH:mm"), 'ShopifyProductID':_.get(emailSent, 'ShopifyProductID','n/a')}
              })

                record.Type = _.startCase(record.Type)
                if (record.DesirablePrice) {
                    record.DesirablePrice = '$' + record.DesirablePrice.toFixed(2)
                }
                // if (_.size(_.get(record,'EmailsSent', []))) {
                //     record.EmailsSent =  JSON.stringify(record.EmailsSent)
                // }
                if (!_.isEmpty(_.get(record,'SubscriptionCustomData', {}))) {
                    record.Data =  JSON.stringify(record.SubscriptionCustomData)
                }
               record.createdAt  = moment(record.createdAt).format("YYYY-MM-DD")

                return  record
               // return {...record, ...customData}
            })
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
                unwindPath: 'UserID'
            })

               var filename = "report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }

        }).catch(err => {
            console.log('err', err );
        });
    }
    handleDownloadComplete(){
        console.log(' handleDownloadComplete',true );
        this.setState({'downloadReport':false});
    }
    onSelectTab(event){
         this.setState({displayReportTab:!this.state.displayReportTab})
    }
    render() {

        // if (_.size(self.state.filterOptions.ageGroup) >0 ){
        //     ageRanges.unshift({value: false, label: 'All groups'});
        //  }
        return (
            <div className="action-block">
                <Tabs defaultActiveKey={''} onSelect={(e)=>{this.onSelectTab(e)}} id="contractorActionBox" >

                        <Tab eventKey={'reports'}  unmountOnExit={true} title="Reports" >
                            <Row className= {this.state.displayReportTab ? '':'hidden'}>
                                <Col md={4} xs={4} className="top10">
                                    <Select
                                        tabIndex="0"
                                        searchable ={true}
                                        multi
                                        selectedOptions
                                        clearable={false}
                                        placeholder="Included fields"
                                        options={allReportFieldList}
                                        onChange={ (selectedOptions)=> this.setState({'reportFields': selectedOptions})}
                                        //  filterOptions={filterOptions}
                                        value={this.state.reportFields}
                                    />
                                </Col>

                            </Row>
                            <Row>

                                <Col md={3} xs={6} className="top10">
                                     <button className="btn btn-primary" disabled={this.state.pending} onClick={ this.downloadReport.bind(this)}
                                            type="button">
                                        Download report
                                    </button>



                                </Col>
                            </Row>
                        </Tab>

                    </Tabs>

                </div >
        );

    }
}



